import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { PartWithChildrenDto } from "../infra/fetchPartWithChildren.api";
import { partWithChildrenQuery } from "../infra/partWithChildren.query";

export const usePartWithChildren = (
  id: string | undefined,
  options?: {
    refetchInterval?: UseQueryOptions<PartWithChildrenDto>["refetchInterval"];
    enabled?: boolean;
  },
) => {
  const { data, ...rest } = useQuery({
    ...partWithChildrenQuery(id),
    refetchInterval: options?.refetchInterval,
    enabled: options?.enabled,
  });

  return { part: data, ...rest };
};
